import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

import ModalBase from "../modalBase/modalBase";
import AvoidTagsFilter from "../avoidTagsFilter/avoidTagsFilter";

@Component({
  components: {
    ModalBase,
    AvoidTagsFilter,
  },
})
export default class TagsModal extends Vue {
  @Prop({ default: false }) isActive;

  @Getter getSubscription;
  @Getter getCity;

  @Action action_getTags;
  @Action action_updateSubscription;

  availableTags = [];
  isLoading = false;
  favouriteFood = "";
  selectedTags = [];
  errors = [];

  get getProteinTags() {
    return this.availableTags.filter((tag) => tag.type_tag === "aggregate");
  }

  get getProductsTags() {
    return this.availableTags.filter((tag) => tag.type_tag === "avoid");
  }

  async mounted() {
    await this.fetchTags();
    this.setInitialData();
  }

  async fetchTags() {
    this.isLoading = true;
    this.availableTags = await this.action_getTags();
    this.isLoading = false;
  }

  @Watch("isActive")
  setInitialData() {
    this.selectedTags = JSON.parse(JSON.stringify(this.getSubscription.tags));
    this.favouriteFood = this.getSubscription.comments;
  }

  onSelectTag(newTag) {
    const findIndex = this.selectedTags.findIndex((tag) => tag.id === newTag.id);
    if (findIndex === -1) this.selectedTags.push(newTag);
    else this.selectedTags.splice(findIndex, 1);
  }

  async updateSubscription() {
    this.errors = [];
    if (this.favouriteFood.length === 0) {
      this.errors.push("no-favourite-food");
      return;
    }
    const tags = this.selectedTags.map((tag) => tag.id);
    const payload = {
      commerceId: this.getCity.id,
      subscriptionId: this.getSubscription.id,
      subscription: {
        subscription: {
          tags,
          comments: this.favouriteFood,
        },
      },
    };
    try {
      this.isLoading = true;
      await this.action_updateSubscription(payload);
      this.isLoading = false;
      this.$emit("modal-close");
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `No fue posible actualizar la suscripción ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
  }

  isError(errorName: string) {
    return this.errors.findIndex((error) => error === errorName) !== -1;
  }
}
